import { BacklogError } from "./BacklogError";

export class BacklogAssertionError extends BacklogError {}
